import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CdkDialogContainer } from '@angular/cdk/dialog';
import { CdkPortalOutlet } from '@angular/cdk/portal';

@Component({
  selector: 'homi-dialog-container',
  templateUrl: 'dialog-container.component.html',
  styleUrls: ['dialog-container.component.scss'],
  imports: [CdkPortalOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogContainerComponent extends CdkDialogContainer {}
